const parse = (d) => {
  const [y, m, day] = (d || "2000-01-01").split("-").map(Number);
  return new Date(y, m - 1, day);
};

export const weekday = (d) => parse(d).toLocaleDateString("en-CA", { weekday: "long" });
export const weekdayShort = (d) => parse(d).toLocaleDateString("en-CA", { weekday: "short" });
export const monthShort = (d) => parse(d).toLocaleDateString("en-CA", { month: "short" });
export const monthLong = (d) => parse(d).toLocaleDateString("en-CA", { month: "long" });
export const dayNum = (d) => parse(d).getDate();
export const fullDate = (d) =>
  parse(d).toLocaleDateString("en-CA", { weekday: "long", month: "long", day: "numeric", year: "numeric" });

export const time12 = (t) => {
  const [h, m] = (t || "0:00").split(":").map(Number);
  const suffix = h >= 12 ? "PM" : "AM";
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${suffix}`;
};

export const cad = (n) => (n == null ? null : `CA$${Number(n).toFixed(0)}`);

export const showDateTime = (c) => {
  const [y, m, d] = (c?.date || "2000-01-01").split("-").map(Number);
  const [h, min] = (c?.show_time || "20:00").split(":").map(Number);
  return new Date(y, m - 1, d, h, min);
};

export const canBuy = (c) => !c?.is_past && (c?.status === "On Sale" || c?.status === "Limited Availability");
